<template>
  <div class="mobile-edit-complete">
    <div class="section">
      <div class="container">
        <div v-if="isSuccess">
          <h2>{{ message }}</h2>
          <div class="main-area">
            カード情報の変更が完了しました。
          </div>
          <div class="sub-area">
          </div>
        </div>
        <!-- <div v-else-if="isRetry">
          <h2 style="text-align:left">このログインユーザではカード変更できません。<br>アカウントを登録したユーザでログインし直してください。</h2>
        </div> -->
        <div v-else-if="isError || isRetry">
          <div class="main-area">
            <ul>
              <li>{{ message }}</li>
            </ul>
          </div>
          <div class="sub-area">
            <ul>
              <li>再度操作を行うか、RiceLogのお問い合わせページより、お問い合わせください。</li>
            </ul>
          </div>
        </div>
      </div>
      <div v-if="isRetry" id="button-area">
        <div class="left-box"/>
        <div class="center-box">
          <span class="btn btn-submit active" @click="onClickRetry">再度カード変更を行う</span>
        </div>
        <div class="right-box"/>
      </div>
      <div id="button-area">
        <div class="left-box"/>
        <div class="center-box">
          <span class="btn btn-submit active" @click="onClickLogin">ログイン画面に戻る</span>
        </div>
        <div class="right-box"/>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "@/mixins/loader";
import { PAYMENT_RESULT_CODE } from "@/constants/constants";


export default {
  props:{
    result: String,
    message: String
  },
  data() {
    return {};
  },

  mixins: [Loader],

  computed: {
    isSuccess() {
      return this.result === PAYMENT_RESULT_CODE.Success;
    },
    isError() {
      return this.result === PAYMENT_RESULT_CODE.Error;
    },
    isRetry() {
      return this.result === PAYMENT_RESULT_CODE.Retry;
    },
  },
  mounted() {
    document.getElementById('container').scrollIntoView({
        behavior: 'instant',
        block: 'start'
    });
    if (this.isRetry) {
      return;
    }
    // this.loading(async () => {
    //   await this.signOut();
    // });
  },

  methods: {
    onClickRetry() {
        this.$router.push({ name: "mobile-payment-edit" });
    },
    onClickLogin() {
      this.loading(async () => {
        await this.signOut();
        this.$router.go({ path: "/mobile-edit", force: true });
      });
    },

    async signOut() {
      try {
        await this.$Amplify.Auth.signOut();
      } catch (e) {
        console.log(e);
      }
    }
  },
};
</script>

<style lang="scss">
.mobile-edit-complete {
  .section {
    overflow: auto;
    width: 100%;
    height: 100%;
    position: relative;
    margin: auto;
    background: white;

    .container {
      margin: 2rem;

      h2 {
        text-align: center;
        font-weight: 400;
      }

      .main-area {
        text-align: center;
      }
      .main-area ul {
        list-style-type: none;
        padding-inline: unset;
      }

      .main-area a {
        margin: 0.5rem;
      }

      .sub-area ul {
        padding-inline: unset;
        // padding-inline-start: 20px;
        // padding-inline-end: 0px;
        list-style-type: none;
      }

      .sub-area a {
        margin: 0.5rem;
      }
    }
  }
  .card-area {
    text-align: center;
    margin: 2rem;
  }
  .card-area.complete {
    display: none;
  }
  #payjp_checkout_box input[type="button"] {
    font-size: 16px;
  }
  #message-area {
    margin: 2rem;
  }

  #button-area {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    // margin: 0px auto 40px;

    .right-box {
      right: 0;
      bottom: 0;
      width: 10%;
    }
    .center-box {
      display: inline;
      text-align: center;
      width: calc(100% - 20%);
    }
    .left-box {
      left: 0;
      bottom: 0;
      width: 10%;
    }
    .btn {
      display: inline-block;
      background: white;
      font-size: 14px;
      text-align: center;
      min-width: 130px;
      min-height: 40px;
      border-radius: 20px;
      color: var(--purple);
      padding: 10px 20px;
      margin: 10px auto 10px;
      cursor: pointer;
      &.disable {
        opacity: 0.5;
        cursor: inherit;
        pointer-events: none;
      }
      &.btn-submit {
        background: var(--purple);
        color: #fff;
        margin-left: 10px;
        margin-right: 10px;
      }
      &.btn-cancel {
        background: var(--purple-tertiary);
        color: #000;
        margin-left: 10px;
        margin-right: 10px;
      }
    }
  }
}
</style>
